import {api, getApiError, handleApiError, ServiceResponse} from "../ApiClient";

export type FeeTier = { threshold: number; fee: number };

export type ConnectedAccount = {
    canAcceptPayouts: boolean;
    canAcceptPayments: boolean;
    currency: string;
    feeTiers: number[][];
};

export interface ConnectedAccountResponse extends ServiceResponse {
    account?: ConnectedAccount
}


export const ConnectedAccountService = () => {

    const get = async (userId: string): Promise<ConnectedAccountResponse> => {
        return api.get<ConnectedAccount>(`/api/1/user-connected-accounts/${userId}`)
            .then((resp) => {
                if (resp && resp.status === 200) {
                    return {
                        account: resp.data
                    }
                }

                let e = getApiError(resp)
                return {
                    error: {
                        apiError: e,
                        message: e.message ? e.message : "Unknown error occurred."
                    }
                }
            })
            .catch(handleApiError)
    }


    return {
        getAccount: get
    }
}
